import type {
  Bet,
  HistoricalBetState,
  HistoricalBetsPayload,
  RawHistoricalBetsPayload
} from '../../types/historicalBets';

const isBetsCountGreaterThanZero = (
  payload: RawHistoricalBetsPayload
): payload is HistoricalBetsPayload => payload.betsCount > 0;

const addIsSettledToBet = (bet: Bet, isSettled?: boolean): Bet => ({
  ...bet,
  isSettled: !!isSettled
});

const betsLoadedSuccessfully = (
  state: HistoricalBetState,
  payload: RawHistoricalBetsPayload
): HistoricalBetState => {
  if (state.isSettled !== payload.isSettled) {
    return state;
  }

  if (isBetsCountGreaterThanZero(payload)) {
    const bets = [
      ...state.bets,
      ...payload.content.Bets.bet.map((bet) => addIsSettledToBet(bet, payload.isSettled))
    ];

    const filteredBets = bets.filter((bet) => bet.isSettled === !!state.isSettled);

    const uniqueBetIds = [...new Set(filteredBets.map((bet) => bet.id))];

    const uniqueBets = uniqueBetIds.map((id) => filteredBets.find((bet) => bet.id === id)) as Bet[];

    return {
      ...state,
      isFetching: false,
      bets: uniqueBets,
      moreAvailable: uniqueBets.length < payload.betsCount
    };
  }

  return {
    ...state,
    isFetching: false,
    bets: []
  };
};

export default betsLoadedSuccessfully;
